import fetch from "../fetch";

export default ({ dealCode }) =>
  fetch({ method: "DELETE", path: `/clo/deals/${dealCode}` });
